export default __webpack_public_path__ + "static/landing_video-11c457bb56eacb54b7c5768385b9ebcc.mp4";